const techAndInnovationCategories = [
  { title: "Audio" },
  { title: "Camera Gear" },
  { title: "Education" },
  { title: "Energy & Green Tech" },
  { title: "Fashion & Wearables" },
  { title: "Food & Beverages" },
  { title: "Health & Fitness" },
  { title: "Home" },
  { title: "Phones & Accessories" },
  { title: "Productivity" },
  { title: "Transportation" },
  { title: "Travel & Outdoors" },
];

const creativeWorksCategories = [
  { title: "Art" },
  { title: "Comics" },
  { title: "Dance & Theater" },
  { title: "Film" },
  { title: "Music" },
  { title: "Photography" },
  { title: "Podcasts, Blogs & Vlogs" },
  { title: "Tabletop Games" },
  { title: "Video Games" },
  { title: "Web Series & TV Shows" },
  { title: "Writing & Publishing" },
];

const communityCategories = [
  { title: "Culture" },
  { title: "Environment" },
  { title: "Human Rights" },
  { title: "Local Businesses" },
  { title: "Wellness" },
];

const allCategories = [
  ...techAndInnovationCategories,
  ...creativeWorksCategories,
  ...communityCategories,
];

export default allCategories;
